export default {
    backendUrl: "https://loginv2.brigosha.com",
    socketUrl: "https://ibelong.brigosha.com"
}
// https://testibelong.brigosha.com
// dusted

